// @flow
import type { ID, AppState, Selector } from '../../core/types'
import type { Address } from '../myprofile/types'
import { createSelector } from 'reselect'
import { hget } from '../../modules/hash'
import {
  isCommInProgress,
  getCommunicationState,
  COMM_STATES
} from '../../modules/communication'
import { domains } from '../constants'
import { USER_ADDRESSES } from './constants'

export const isFetchSessionInProgress = (state: AppState): boolean =>
  isCommInProgress(domains.SESSION, state)

export const isSessionLoaded = (state: AppState): boolean =>
  getCommunicationState(domains.SESSION, (state: AppState)) ===
    COMM_STATES.Success ||
  getCommunicationState(domains.SESSION, (state: AppState)) ===
    COMM_STATES.Failure

export const isLoggedIn = (state: AppState): boolean =>
  getCommunicationState(domains.SESSION, (state: AppState)) ===
    COMM_STATES.Success && !!getUserId(state)

export const getCurrentUserId: Selector<ID> = hget('session', 'userId')

export const getUserId = (state: AppState): Selector<ID> =>
  hget(domains.SESSION, 'userId', state)

export const getUserDataInfo: Selector<any> = createSelector(
  hget(domains.SESSION, 'userId'),
  hget(domains.SESSION, 'name'),
  hget(domains.SESSION, 'lastName'),
  hget(domains.SESSION, 'phone'),
  hget(domains.SESSION, 'email'),
  (userId, name, lastName, phone, email) => ({
    id: userId,
    name,
    lastName,
    phone,
    email
  })
)

export const getUserName: Selector<string> = createSelector(
  hget(domains.SESSION, 'name'),
  hget(domains.SESSION, 'lastName'),
  (first = 'Guest', last = 'user') => first + ' ' + last
)

export const getEmail: Selector<string> = createSelector(
  hget(domains.SESSION, 'email'),
  email => email
)
export const getAddresses = (state: AppState): Selector<Address[]> =>
  hget(domains.SESSION, USER_ADDRESSES, state)

export const getAddress = (addressId: ID): Selector<Address> =>
  createSelector(getAddresses, allAddresses =>
    (allAddresses || []).find(address => address.id === addressId)
  )

export const getUserCharityId: Selector<ID> = hget(domains.SESSION, 'charityId')

export const getClientToken = (state: AppState): Selector<string> =>
  hget(domains.SESSION, 'clientToken', state)

export const isUserProfileCompleted: Selector<Boolean> = createSelector(
  hget(domains.SESSION, 'paymentMethods'),
  methods => (methods ? Boolean(methods.length) : false)
)

export const getPaymentMethods: Selector<ID[]> = hget(
  domains.SESSION,
  'paymentMethods'
)

export const hasPaymentMethods: Selector<Boolean> = createSelector(
  getPaymentMethods,
  paymentMethods => paymentMethods && Boolean(paymentMethods.length)
)

export const isEmailVerified: Selector<Boolean> = hget(
  domains.SESSION,
  'isVerified'
)



// WEBPACK FOOTER //
// ./src/services/session/selectors.js